import { IndicatorsRenderer } from '../../../core/components/annotations/components/indicators/IndicatorsRenderer.js';
import { getUniqueIndicatorsByPriority } from '../../../core/components/annotations/components/indicators/utils/get-unique-indicators-by-priority.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useHistogramAnnotationsData } from '../../hooks/useHistogramAnnotationsData.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';

export const HistogramAnnotationsIndicators = () => {
  const { indicators } = useHistogramAnnotationsData();
  const { xScale } = useHistogramXScale();

  const uniqueIndicators = getUniqueIndicatorsByPriority(
    indicators,
    xScale.domain(),
  );

  return (
    <svg className={plotLayout}>
      {uniqueIndicators.map((track, index) =>
        track.map(([key, indicator]) => (
          <IndicatorsRenderer
            key={key}
            {...indicator}
            trackIndex={index}
            scale={xScale}
          />
        )),
      )}
    </svg>
  );
};
